<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import Plan from "@/components/widgets/plan-card";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Stat,
    Plan,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      ip: null,

      statData: [
        { title: "Status", value: "-" },
      ],

      client: null,
      plan: null,
      plans: null,

      choose: {
        modal: false,
        loading: false,
        id: '',
        name: '',
        description: '',
        value: '',
        service: [],
      },

      confirm: {
        loading: false,
      },

      payment: {
        loading: false,
      },

      payments: null,

      upgrade: {
        available: false,
        modal: false,
        loading: false,
        id: '',
        name: '',
        description: '',
        value: '',
      },
    };
  },
  methods: {
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.ip = data.ip;
          }
        });
    },
    getCurrent() {
      this.plan = null;

      this.statData = null;

      this.choose.modal = false;
      this.choose.loading = false;
      this.choose.id = '';
      this.choose.name = '';
      this.choose.description = '';
      this.choose.value = '';
      this.choose.service = [];

      api
        .get('subscriptions/current')
        .then((response) => {
          if (response.data.status == 'success') {
            this.client = response.data.client
            this.plan = response.data.current

              this.statData = [
                { title: "Plano", value: this.plan.name },
                { title: "Status", value: this.client.status },
              ]
          }
        })
    },
    getPlans() {
      this.plans = null;

      api
        .get('subscriptions')
        .then((response) => {
          if (response.data.status == 'success') {
            this.plans = response.data.list;
          }
        })
    },
    getUpgrade() {
      this.upgrade.available = false;
      this.upgrade.id = '';
      this.upgrade.name = '';
      this.upgrade.description = '';
      this.upgrade.value = '';

      api
        .get('subscriptions/upgrade')
        .then((response) => {
          if (response.data.status == 'success' && response.data.plan) {
            this.upgrade.available = true;
            this.upgrade.id = response.data.plan.id;
            this.upgrade.name = response.data.plan.name;
            this.upgrade.description = response.data.plan.description;
            this.upgrade.value = response.data.plan.value;
          } else {
            this.upgrade.available = false;
          }
        })
    },
    showChoose(plan) {
      this.choose.modal = false;
      this.choose.modal = true;
      this.choose.id = plan.id;
      this.choose.name = plan.name;
      this.choose.description = plan.description;
      this.choose.value = plan.value;
      this.choose.service = plan.service;
    },
    choosePlan() {
      if (this.choose.id) {
        this.choose.loading = true;

        api
          .post('subscriptions/choose', {
            id: this.choose.id
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.$router.push('/subscriptions/' + response.data.order.id);
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch((error) => {
            if (error) {
              this.choose.modal = false;
              this.choose.loading = false;
            }
          })
          .finally(() => {
            this.choose.modal = false;
            this.choose.loading = false;
          });
      }
    },
    changePlan() {
      this.client = null;
      this.plan = null;
      this.plans = null;

      api
        .post('subscriptions/change')
        .then((response) => {
          if (response.data.status == 'success') {
            this.getCurrent();
            this.getPlans();
            this.getPayments()
          } else {
            this.$toast.error(response.data.message);
          }
        })
    },
    confirmPlan() {
      this.confirm.loading = true;

      api
        .post('subscriptions/confirm', {
          ip: this.ip
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.getCurrent();
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
        })
        .finally(() => {
          this.confirm.loading = false;
        });
    },
    makePayment() {
      this.payment.loading = true;
    },
    getPayments() {
      this.payments = null;

      api
        .get('subscriptions/payments')
        .then((response) => {
          if (response.data.status == 'success') {
            this.payments = response.data.list;
          } else {
            this.payments = null;
          }
        })
    },
    showUpgrade() {
      if (this.upgrade.available) {
        this.upgrade.modal = false;
        this.upgrade.modal = true;
      }
    },
    buyUpgrade() {
      if (this.upgrade.id) {
        this.upgrade.loading = true;

        api
          .post('subscriptions/upgrade', {
            id: this.upgrade.id
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.$router.push('/subscriptions/' + response.data.order.id);
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch((error) => {
            if (error) {
              this.upgrade.modal = false;
              this.upgrade.loading = false;
            }
          })
          .finally(() => {
            this.upgrade.modal = false;
            this.upgrade.loading = false;
          });
      }
    }
  },
  mounted() {
    this.getIp()
    this.getCurrent()
    this.getPlans()
    this.getPayments()
    this.getUpgrade()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/subscriptions">Meu Plano</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meu Plano</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!client && !plans" class="text-center">
      <b-spinner class="ml-2 align-middle" variant="default" role="status"></b-spinner>
    </div>
    <template v-else-if="client && client.status == 'await_plan'">
      <div v-if="plans && plans.length > 0">
        <div class="row">
          <div class="col-lg-4" v-for="(row, index) in plans" :key="index">
            <div class="card">
              <div class="card-body">
                <h5 class="mb-0 text-center">{{ row.name }}</h5>
                <h2 class="mb-3 text-center">{{ row.value | currency }}</h2>
                <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="showChoose(row)">
                  Escolher
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">
        Nenhum plano disponível no momento.
      </div>
    </template>
    <template v-else-if="client && client.status == 'plan_chosen'">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="mb-0">Você escolheu o plano</h5>
        <button class="btn btn-outline-default py-1 rounded-sm" v-on:click="changePlan();">Alterar</button>
      </div>
      <Plan :plan="plan" />
      <div class="row">
        <div v-for="stat of statData" :key="stat.icon" class="col-md-3 col-lg-3 col-xl-3">
          <Stat :title="stat.title" :value="stat.value" />
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'active'">
      <div class="row align-items-center">
        <div v-for="stat of statData" :key="stat.icon" class="col-md-3 col-lg-3 col-xl-3">
          <Stat :title="stat.title" :value="stat.value" />
        </div>
        <div v-if="upgrade && upgrade.available" class="col-12 col-md-3 ml-md-auto text-md-right mb-3">
          <button class="btn btn-default btn-block btn-lg d-block d-md-inline-block" v-on:click="showUpgrade()">
            Upgrade
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'overdue'">
      <Plan :plan="plan" />
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(255, 0, 0, 1);">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
              </svg>
            </div>
            <div>
              <strong>O pagamento do seu plano está em atraso!</strong>
            </div>
          </div>
          <button class="btn btn-default btn-block mt-3" v-on:click="makePayment();" :disabled="this.payment.loading">
            Realizar pagamento
            <b-spinner v-if="payment.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'suspended'">
      <Plan :plan="plan" />
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: rgba(255, 0, 0, 1);">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
              </svg>
            </div>
            <div>
              <strong>O seu plano está suspenso por falta de pagamento!</strong>
            </div>
          </div>
          <button class="btn btn-default btn-block mt-3" v-on:click="makePayment();" :disabled="this.payment.loading">
            Realizar pagamento
            <b-spinner v-if="payment.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="client && client.status == 'inactive'">
      <Plan :plan="plan" />
    </template>

    <fieldset v-if="payments && payments.length > 0">
      <legend>Histórico</legend>
      <div class="table-responsive">
        <table class="table table-centered table-nowrap">
          <thead class="thead-light">
            <tr>
              <th>Plano</th>
              <th>Valor</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in payments" :key="row.index">
              <td>
                {{ row.plan }}
              </td>
              <td>{{ row.value | currency }}</td>
              <td>
                <span class="badge badge-soft-danger font-size-13" v-if="row.status == 'pending'">PENDENTE</span>
                <span class="badge badge-soft-success font-size-13" v-else-if="row.status == 'approved'">APROVADO</span>
                <span class="badge badge-soft-warning font-size-13" v-else-if="row.status == 'canceled'">CANCELADO</span>
              </td>
              <td class="text-right">
                <router-link v-if="row.order.id" :to="'/subscriptions/' + row.order.id" class="btn btn-default btn-rounded">
                  Ver
                  <i class="mdi mdi-arrow-right ml-1"></i>
                </router-link>
                <button v-else class="btn btn-default btn-rounded" disabled>
                  Ver
                  <i class="mdi mdi-arrow-right ml-1"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>

    <b-modal v-model="choose.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar escolha</h4>
        <p>Confirma a escolha do plano <strong>{{ choose.name }}</strong>?</p>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" v-on:click="choosePlan()" :disabled="this.choose.loading">
            Confirmar
            <b-spinner v-if="choose.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="choose.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="upgrade.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar upgrade</h4>
        <p>Confirma o upgrade para o plano <strong>{{ upgrade.name }}</strong>?</p>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" v-on:click="buyUpgrade()" :disabled="this.upgrade.loading">
            Confirmar
            <b-spinner v-if="upgrade.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="upgrade.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>